import http from './http';

export function uploadImage(recordId: string, file: any) {
  const formData = new FormData();

  formData.set('recordId', recordId);
  formData.set('image', file);

  return http.post('/api/file/upload', formData);
}
